import type { Projectile } from "../sim/types";
import { glowTempK } from "./heat-glow";
import type { Renderer } from "./renderer";

export function pushProjectileTiles(r: Renderer, projectiles: Iterable<Projectile>): void {
  for (const p of projectiles) {
    const uv = r.atlas.lookup.get(p.sprite);
    if (!uv) continue;
    const aspect = uv.pxW / uv.pxH;
    const sh = p.size;
    const sw = sh * aspect;
    const rot = Math.atan2(p.vel.y, p.vel.x);
    r.pushTileRaw(
      p.pos.x, p.pos.y,
      sw, sh,
      rot, 0,
      uv.u, uv.v, uv.w, uv.h,
      glowTempK(p.tempK), 0, p.emissivity,
      p.vel.x, p.vel.y, 0,
    );
  }
}
